const forms = {
    addEvents(element,select=false){
        if(select || (element.type !== 'radio' && element.type !== 'checkbox')) {
            if(element.value.length > 0){
                element.parentNode.classList.add('filled');
            }
            element.addEventListener("focus", (e) => {
                e.target.parentNode.classList.add('focus');
                if(e.target.parentNode.dataset.focus !== undefined){
                    document.getElementsByTagName('body')[0].classList.add(e.target.parentNode.dataset.focus);
                }
            });
            element.addEventListener("focusout", (e) => {
                e.target.parentNode.classList.remove('focus');
                if(e.target.parentNode.dataset.focus !== undefined && e.target.value.length < 1){
                    document.getElementsByTagName('body')[0].classList.remove(e.target.parentNode.dataset.focus);
                }
            });
            element.addEventListener("change", (e) => {
                if (e.target.value.length > 0) {
                    e.target.parentNode.classList.add('filled');
                } else {
                    e.target.parentNode.classList.remove('filled');
                }
            });
        }
        if(!select) {
            element.addEventListener("keyup", (e) => {
                if (e.target.value.length > 0) {
                    e.target.parentNode.classList.add('filled');
                } else {
                    e.target.parentNode.classList.remove('filled');
                }
            });
        }
    },
    load(e=null) {
        const o = (e===null) ? document : document.querySelector(e);
        const formGroups = o.getElementsByClassName('form-group');
        for (const formGroup of formGroups) {
            const inputs = formGroup.getElementsByTagName('input');
            for (const input of inputs) {
                this.addEvents(input);
            }
            const selects = formGroup.getElementsByTagName('select');
            for (const select of selects) {
                this.addEvents(select);
            }
        }
    }
};

window.forms = forms;
window.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => forms.load(),0);
});
if( document.readyState !== 'loading' ) {
    setTimeout(() => forms.load(),0);
}
